import { useMemo } from "react";

import {
    DirectoryEntityType
} from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import {
    DirectoryEntityAddDto,
    DirectoryEntityExistsParameters,
    DirectoryEntityModifyDto,
    DirectoryEntitySearchDto,
    DirectoryEntitySearchDuplicateDto
} from "../Api/ClientParameters/DirectoryEntityDto";
import { ContactDirectoryClient, SearchResponse } from "../Api/ContactDirectoryClient";
import { DuplicateSearchType } from "../Models/enums/DuplicateSearchType";

interface IDirectoryClientActions {
    add: (model: DirectoryEntityAddDto) => Promise<DirectoryEntitySearchDto>;
    modify: (model: DirectoryEntityModifyDto) => Promise<DirectoryEntitySearchDto>;
    search: (
        searchText: string,
        types?: DirectoryEntityType[],
        countryId?: string,
        stateId?: string,
        exclusiveGeographicSearch?: boolean
    ) => Promise<SearchResponse>;
    exists: (dto: DirectoryEntityExistsParameters) => Promise<boolean>;
    flagAsInvalid?: (id: string, reason: string) => Promise<void>;
    searchDuplicates?: (entityId: string, dto: DirectoryEntitySearchDuplicateDto, type: DirectoryEntityType, duplicateSearchType: DuplicateSearchType) => Promise<SearchResponse>;
}

export const useDirectoryClientForType = (type: DirectoryEntityType, isEditMode: boolean = true): IDirectoryClientActions => useMemo<IDirectoryClientActions>(
    () => {
        const client = ContactDirectoryClient.getInstance();

        const actions: IDirectoryClientActions = {
            add: async model => await client.create(type, model),
            modify: async model => isEditMode && await client.modify(type, model),
            search: async (searchText, types, countryId, stateId, exclusiveGeographicSearch) => await client.search(searchText, types, countryId, stateId, exclusiveGeographicSearch),
            exists: async dto => await client.exists(type, dto),
            searchDuplicates: async (entityId, dto, type, duplicateSearchType) => await client.searchDuplicates(entityId, dto, type, duplicateSearchType)
        };

        if (isEditMode)
            actions.flagAsInvalid = async (id, reason) => await client.flagAsInvalid(type, id, reason);

        return actions;
    },
    [type, isEditMode]
);
